'use client';
import React, { Suspense } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import AppLayout from '@/components/AppLayout';
import AcceptedBidDetailsContent from './components/AcceptedBidDetailsContent';

export default function AcceptedBidDetailsPage() {
  const { user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (!loading && !user) {
      router?.push('/sign-up-login-screen');
    }
  }, [user, loading, router]);

  if (loading || !user) return null;

  return (
    <AppLayout role="customer">
      <Suspense fallback={<div className="flex items-center justify-center h-full" />}>
        <AcceptedBidDetailsContent />
      </Suspense>
    </AppLayout>
  );
}
